import React from "react"
import HeroSlides from "../components/hero-slides"
import Layout from "../components/layout"

import Footer from "../components/footer"

import SocialIconsFooter from "../components/social-icons-footer"

import Projects from "../components/projects"

const IndexPage = () => {
    return (
        <Layout
            pageTitle="PragICTS | Our Perspectives"
        >
            <div id="wrapper">
                <div className="scroll-nav-wrap fl-wrap">
                    <div className="scroll-down-wrap">
                        <div className="mousey">
                            <div className="scroller"></div>
                        </div>
                        <span>Scroll Down</span>
                    </div>
                   
                </div>

                <HeroSlides />

                <div className="content">

                    {/* overview section */}
                    <Projects />
                 
                    

                    <SocialIconsFooter />
                </div>
                <Footer />
            </div>
        </Layout>
    )
}

export default IndexPage
